// src/pages/SalaryPage.js

import React from 'react';
import SalaryZipUpload from '../components/SalaryZipUpload';

const SalaryPage = () => {
    return (
        <div className="container mt-5">
            {/*<h2>給与データ管理</h2>*/}
            <SalaryZipUpload />
        </div>
    );
};

export default SalaryPage;